
export type UploadLectureResource200 = {
  /** 미디어 ID */
  mediaId?: string;
  /** 업로드된 파일의 URL */
  url?: string;
};
